/**
 * Customer-visible live price card elements (admin mirror of PWA filter).
 * Keep in sync with pwa/.../customerIntakeElements.js and
 * backend/.../customerVisibleElements.js.
 */

const INTERNALLY_ESTIMATED_TYPES = new Set([
  "transport_tariff",
  "distance_rate",
]);

const INTERNALLY_ESTIMATED_GROUPS = new Set([
  "shared_load",
  "exclusive_load",
  "local_mileage",
  "local_minimum",
  "local_volume",
]);

export function isInternallyEstimatedElement(element = {}) {
  return (
    INTERNALLY_ESTIMATED_TYPES.has(element.type) ||
    INTERNALLY_ESTIMATED_GROUPS.has(element.group)
  );
}

export function isCustomerVisibleIntakeElement(element = {}) {
  return element.active !== false && !isInternallyEstimatedElement(element);
}

export function filterCustomerIntakeElements(elements = []) {
  return (Array.isArray(elements) ? elements : []).filter(
    isCustomerVisibleIntakeElement,
  );
}

export function isAccessChecklistElement(element = {}) {
  const type = String(element?.type || "").toLowerCase();
  const group = String(element?.group || "").toLowerCase();
  const id = String(element?.id || "").toLowerCase();
  return (
    type === "access_condition" ||
    group === "access" ||
    group.includes("access") ||
    id.startsWith("access:")
  );
}
